export const stats = [
  { value: '+100', label: 'Units Ready' },
  { value: '+2,000', label: 'Teachers Satisfied' },
  { value: '3,500+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+100', label: 'Ready-to-Teach Units' },
  { value: '10', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours planning every single class',
  'Repetitive or disconnected activities',
  'No clear path from Primary to Secondary',
  'Not knowing how to grade complex essays',
  'Unmotivated or confused students',
]

export const afterItems = [
  "5-minute review and you're set",
  'Varied units from Phonics to Rhetoric',
  'A logical 10-year progression',
  'Rubrics and assessments ready-made',
  'Students thinking and writing at a high level',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriving to class without knowing what text or unit to teach next',
  },
  {
    emoji: '⏱️',
    text: 'Spending hours searching for worksheets that actually look professional',
  },
  {
    emoji: '🤷',
    text: 'Not knowing how to teach complex topics like Rhetoric or Tragedy without sounding boring',
  },
  {
    emoji: '📋',
    text: 'No clear rubrics aligned with global standards (USA, UK, AU)',
  },
  {
    emoji: '😓',
    text: 'Students always doing the same thing, lessons not evolving in complexity',
  },
  { emoji: '🌙', text: 'Still not ready for Monday by Sunday night' },
]

export const packItems = [
  {
    emoji: '📚',
    title: '5 Primary Volumes',
    text: 'Volumes 1–5, covering Foundations, Phonics, and Early Reading',
  },
  {
    emoji: '🏛️',
    title: '5 Secondary Volumes',
    text: 'Volumes 6–10, covering Syntax, Rhetoric, World Lit, and Essays',
  },
  {
    emoji: '🖋️',
    title: 'Teacher Scripts',
    text: 'Step-by-step guidance on what to say and how to lead the lesson',
  },
  {
    emoji: '📊',
    title: 'Assessments & Rubrics',
    text: 'Ready-made tools for every skill level',
  },
  {
    emoji: '🔬',
    title: 'Close Reading Units',
    text: 'Line-by-line analysis frameworks for deep meaning',
  },
  {
    emoji: '📖',
    title: 'Neutral Global Curriculum',
    text: 'Adapted for any English-speaking school system',
  },
]

export const instantItems = [
  'The 10 complete digital volumes (Primary and Secondary Series)',
  'Teacher scripts, illustrated worksheets, and reading passages',
  'Ready-to-use rubrics for grading writing, reading, and speaking',
  'Exam-ready frameworks for high-performance essay writing',
  'Comprehensive answer keys for every single exercise',
]

export const bonuses = [
  {
    title: 'The 5-Minute English Class Starter Vault™',
    subtitle: '100 warm-ups ready to use',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4ef1ca64-874a-4edc-b3c4-8c2f3fb8024b.jpg',
  },
  {
    title: 'The Emergency Sub Plan Survival Kit™',
    subtitle: "10 days of classes when you can't be there",
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/fd2982a2-d713-4034-af2c-ec41cf3a3aa3.jpg',
  },
  {
    title: 'The English Ready Implementation Roadmap™',
    subtitle: 'Your step-by-step 12-week plan',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/5a399fdf-3ba4-4e20-a368-e57393d77cb6.jpg',
  },
  {
    title: 'The Fast Feedback & Grading Shortcut Pack™',
    subtitle: 'Cut marking time by 50%',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c47a8868-fd73-4d02-a16f-e215f5c17f70.jpg',
  },
  {
    title: 'The Parent & Admin Communication Script Pack™',
    subtitle: 'Ready-to-copy emails and reports',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e19948d0-717f-4531-bf36-ed7cce77d597.jpg',
  },
]

export const offerRows = [
  { label: '10 Complete Digital Volumes', value: '$77' },
  { label: '5 Exclusive Bonuses', value: '$135' },
]

export const testimonials = [
  {
    quote:
      'I finally have my Sundays back. The secondary units are sophisticated and so easy to implement.',
    name: 'Sarah M.',
    location: 'Austin, USA 🇺🇸',
  },
  {
    quote:
      "The progression from Grade 1 to 10 is the best I've seen. It actually makes sense.",
    name: 'Ella B.',
    location: 'Bristol, UK 🇬🇧',
  },
  {
    quote:
      'The rubrics for essay writing have made my marking nights so much shorter.',
    name: 'Maya K.',
    location: 'Toronto, Canada 🇨🇦',
  },
  {
    quote:
      'A beautiful, high-level resource. It feels made by someone who actually knows the classroom.',
    name: 'Sophie L.',
    location: 'Melbourne, Australia 🇦🇺',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instant PDF download link in your email.',
  },
  {
    q: "Does this work if I'm a beginner teacher?",
    a: 'Yes, the scripts tell you exactly what to do.',
  },
  {
    q: 'What grade levels does this cover?',
    a: 'Grade 1 through Grade 10.',
  },
  {
    q: 'Are the bonuses included?',
    a: 'Yes, if you buy during the launch offer.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. One-time payment for lifetime access.',
  },
]

export const purchaseNotifications = [
  { name: 'Sarah M.', location: 'Austin, USA 🇺🇸', time: '5 min ago' },
  { name: 'Ella B.', location: 'Bristol, UK 🇬🇧', time: '11 min ago' },
  { name: 'Maya K.', location: 'Toronto, Canada 🇨🇦', time: '18 min ago' },
  { name: 'Sophie L.', location: 'Melbourne, Australia 🇦🇺', time: '26 min ago' },
]
